import { useEffect } from 'react';
import '@n8n/chat/style.css';
import { createChat } from '@n8n/chat';
import '../OraculoNuma/OraculoNuma.css'; // Import your custom styles - ADD THIS LINE

const OraculoComponent = () => {
  useEffect(() => {
    createChat({
      webhookUrl: 'https://wilsoncalado.app.n8n.cloud/webhook/8a1a412e-5b94-48e9-8d8b-e4f79c3970ce/chat',
      initialMessages: [],
      i18n: {
        en: {
          title: 'Olá, eu sou a Numa.',
          subtitle: "Estou aqui para conversar, te ouvir e te ajudar na sua jornada espiritual.",
          footer: '',
          getStarted: 'Nova conversa',
          inputPlaceholder: 'Digite sua pergunta...',
        },
        pt: {
          title: 'Hi there! 👋',
          subtitle: "Start a chat. We're here to help you 24/7.",
          footer: '',
          getStarted: 'New Conversation',
          inputPlaceholder: 'Type your question..',
        },
        es: {
          title: 'Hi there! 👋',
          subtitle: "Start a chat. We're here to help you 24/7.",
          footer: '',
          getStarted: 'New Conversation',
          inputPlaceholder: 'Type your question..',
        },
	      defaultLanguage: 'pt',
      },
    });
  }, []);

  return (
    <div
      className="tour-numa-anchor"
      style={{
        position: 'fixed',
        right: '1.5rem',
        bottom: '1.5rem',
        width: '1px',
        height: '1px',
        pointerEvents: 'none',
      }}
    />
  );
};

export default OraculoComponent